import { render, staticRenderFns } from "./GeneralScript.vue?vue&type=template&id=550e64c2"
import script from "./GeneralScript.vue?vue&type=script&lang=js"
export * from "./GeneralScript.vue?vue&type=script&lang=js"
import style0 from "./GeneralScript.vue?vue&type=style&index=0&id=550e64c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports